import { render, staticRenderFns } from "./purchaseorder.vue?vue&type=template&id=469cc4d8&"
import script from "./purchaseorder.vue?vue&type=script&lang=js&"
export * from "./purchaseorder.vue?vue&type=script&lang=js&"
import style0 from "./purchaseorder.vue?vue&type=style&index=0&id=469cc4d8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports